import { combineReducers } from 'redux';

import {
  auth,
  global,
  routing,
  definitions,
  courier,
  order,
  zone,
  slot,
} from './';

export default combineReducers({
  auth,
  courier,
  definitions,
  global,
  order,
  routing,
  zone,
  slot,
});
